import React, { useState, useEffect } from "react";
import {
  Button,
  InputGroup,
  Row,
  Col,
  InputGroupText,
  Modal,
  Form,
  FormFeedback,
  Label,
  Input,
  FormGroup,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Multiselect } from "multiselect-react-dropdown";
import { useFormik } from "formik";
import * as Yup from "yup";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  CREATE_LICENSE_PLAN,
  UPDATE_LICENSE_PLAN,
} from "../../../constants/ApiPaths";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import moment from "moment";



export default function PlanCreateModal(props) {
  const [loading, setLoading] = useState(false);
  const {
    planmodal,
    Licensecategorydetails,
    formData,
    flag,
    SuccessFullRecall,
    templateId,
    plantoggle,
  } = props;
  const { categoryId = "" } = formData;
  const [OptionSet, setOptionSet] = useState(true);
  const [selectedOption, setSelectedOption] = useState([]);
  const [renewal, setRenewal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  // const [Filterstate, setFilterstate] = useState(() => {
  //   let filterInitialKeys = Object.keys(def); // get the key from the initial values for compare the search parameter in  url
  //   let filtersFromURL = {};
  //   for (let param in formData) {
  //     if (filterInitialKeys.includes(param)) {
  //       filtersFromURL[param] = formData[param];
  //     }
  //   }
  //   return { ...def, ...filtersFromURL };
  // });

  const options = Licensecategorydetails.map((i) => ({
    name: i.categoryName,
    value: i.categoryId,
  }));
  const id = JSON.parse(categoryId || "[]");
  const NewOption = options.filter(({ value: id1 }) =>
    id.some(({ categoryId: id2 }) => id2 === id1)
  );
  let SelectedValue = (e) => {
    setOptionSet(false);
    setSelectedOption(e);
  };

  const validationSchema = Yup.object().shape({
    planName: Yup.string().required("Plan Name is Required"),
    planDescription: Yup.string().required("Plan Description Required"),
    planAmount: Yup.number()
      .min(1, "Please enter valid Amount")
      .max(999999, "Please enter valid Amount")
      .positive("Please enter valid Amount")
      .typeError("Please enter valid Amount")
      .required("Plan Amount Required"),
    planType: Yup.string().required("Required"),
    planDuration: Yup.number().test(
      "passwords-match",
      "Required",
      function (value) {
        if (value) {
          return true;
        } else {
          return !(this.parent.planType === "planDuration");
        }
      }
    ),
    validTo: Yup.date()
      .min(new Date(), "Invalid Date")
      .test("passwords-match", "Required", function (value) {
        if (value) {
          return true;
        } else {
          return !(this.parent.planType === "validTo");
        }
      }),
  });

  let CreatePlans = async (values) => {
    const Valid = {
      validTo: {
        planDuration: "",
        isLifeTimePlan: false,
        validTo: values.validTo,
      },
      isLifeTimePlan: {
        planDuration: "",
        isLifeTimePlan: true,
        validTo: "",
      },
      planDuration: {
        planDuration: values.planDuration,
        isLifeTimePlan: false,
        validTo: "",
      },
    };

    setLoading(true);
    if (OptionSet) {
      setSelectedOption(NewOption);
    }

    if (
      renewal &&
      !(values.isParkLicense || values.isKennelLicense || values.isDogLicense)
    ) {
      CustomAlertMessage(
        "Please Select renewal category",
        "error",
        enqueueSnackbar
      );
      setLoading(false);
      return false;
    }
    if (selectedOption.length === 0) {
      setLoading(false);
      CustomAlertMessage("Please Select Category", "error", enqueueSnackbar);
    } else if (
      values.isRenewal ||
      values.isParkLicense ||
      values.isKennelLicense ||
      values.isDogLicense === true
    ) {
      const config = {
        method: flag ? "POST" : "PUT",
        url: flag ? CREATE_LICENSE_PLAN : UPDATE_LICENSE_PLAN,
        headers: authHeader(),
        data: {
          ...values,
          ...Valid[values.planType],
          templateId: templateId,
          categoryId: selectedOption.map((i) => i.value).toString(),
        },
      };
      try {
        const response = await API(config);
        const { status } = response.data;
        if (status === "Success") {
          resetForm({});
          plantoggle();
          setOptionSet(true);
          setSelectedOption([]);
          SuccessFullRecall();
          CustomAlertMessage(
            flag ? "Plan Added Successfully" : "This Plan Updated Successfully",
            "success",
            enqueueSnackbar
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
      CustomAlertMessage(
        "Please Select atleast one license type",
        "error",
        enqueueSnackbar
      );
    }
  };

  const {
    handleSubmit,
    handleChange,
    values,
    handleBlur,
    resetForm,
    setValues,
    errors,
    touched,
  } = useFormik({
    initialValues: formData,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      CreatePlans(values);
    },
  });

 

  let LicenseHandle = (e) => {
    const { name } = e.target;
    setRenewal(e.target.value);
    if (name === "isKennelLicense") {
      setValues({
        ...values,
        isDogLicense: false,
        isParkLicense: false,
        isRenewal: false,
        isKennelLicense: true,
      });
    } else if (name === "isRenewal") {
      setValues({
        ...values,
        isDogLicense: false,
        isParkLicense: false,
        isRenewal: true,
        isKennelLicense: false,
      });
    } else if (name === "isDogLicense") {
      setValues({
        ...values,
        isDogLicense: true,
        isParkLicense: false,
        isRenewal: false,
        isKennelLicense: false,
      });
    } else if (name === "isParkLicense") {
      setValues({
        ...values,
        isDogLicense: false,
        isParkLicense: true,
        isRenewal: false,
        isKennelLicense: false,
      });
    }
  };

  let RenewalLicenseHandle = (e) => {
    const { name } = e.target;
    if (name === "isKennelLicense") {
      setValues({
        ...values,
        isDogLicense: false,
        isParkLicense: false,
        isKennelLicense: true,
      });
    } else if (name === "isDogLicense") {
      setValues({
        ...values,
        isDogLicense: true,
        isParkLicense: false,
        isKennelLicense: false,
      });
    } else if (name === "isParkLicense") {
      setValues({
        ...values,
        isDogLicense: false,
        isParkLicense: true,
        isKennelLicense: false,
      });
    }
  };



  useEffect(() => {
    if (OptionSet) {
      setSelectedOption(NewOption);
    }
  }, [planmodal]);

  const RadioHandleChange = (e) => {
    setValues({ ...values, planType: e.target.id });
  };

  console.log(values, errors, "this.parent.planValidation");

  return (
    <div>
      <Modal
        form="true"
        isOpen={planmodal}
        toggle={() => {
          plantoggle(resetForm({}));
        }}
      >
        <Form onSubmit={handleSubmit}>
          <ModalHeader toggle={plantoggle}>
            {flag ? "Create Plan" : "Update Plan"}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="exampleEmail">Plan Name</Label>
              <Input
                type="text"
                value={values.planName}
                onBlur={handleBlur}
                onChange={handleChange}
                invalid={errors.planName && touched.planName ? true : false}
                name="planName"
                id="exampleEmail"
                placeholder="Enter Plan Name"
              />
              <FormFeedback>
                {errors.planName && touched.planName ? errors.planName : ""}
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="planDescription">Plan Description</Label>
              <Input
                type="text"
                name="planDescription"
                onBlur={handleBlur}
                value={values.planDescription}
                onChange={handleChange}
                invalid={
                  errors.planDescription && touched.planDescription
                    ? true
                    : false
                }
                placeholder="Enter Plan Description"
              />
              <FormFeedback>
                {errors.planDescription && touched.planDescription
                  ? errors.planDescription
                  : ""}{" "}
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="exampleEmail">Plan Amount</Label>
              <InputGroup>
                <Input
                  type="text"
                  name="planAmount"
                  onBlur={handleBlur}
                  value={values.planAmount}
                  onChange={handleChange}
                  invalid={
                    errors.planAmount && touched.planAmount ? true : false
                  }
                  id="exampleEmail"
                  placeholder="Enter Plan Amount"
                />
                <>
                  <InputGroupText>$</InputGroupText>
                </>
              </InputGroup>

              <FormFeedback
                style={{
                  display:
                    touched.planAmount && errors.planAmount ? "block" : "none",
                }}
              >
                {touched.planAmount && errors.planAmount
                  ? errors.planAmount
                  : ""}
              </FormFeedback>
            </FormGroup>
            <Label for="exampleEmail"> Category</Label>
            <Multiselect
              options={options}
              name="category"
              selectedValues={NewOption}
              placeholder="Select Category"
              onSelect={SelectedValue}
              onRemove={SelectedValue}
              displayValue="name"
            />

            <FormFeedback
              style={{
                display: touched.category && errors.category ? "block" : "none",
              }}
            >
              {touched.category && errors.category ? errors.category : ""}
            </FormFeedback>
            <Label for="exampleEmail">Plan Duration ( Choose Any one)</Label>

            <Row>
              <Col>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      onChange={RadioHandleChange}
                      name="planType"
                      id="isLifeTimePlan"
                      checked={
                        values.planType === "isLifeTimePlan" ? true : false
                      }
                    />
                    Life time plan
                  </Label>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      id="planDuration"
                      onChange={RadioHandleChange}
                      checked={values.planType === "planDuration" ? true : false}
                      name="planType"
                    />
                    Plan duration
                  </Label>
                </FormGroup>
              </Col>

              <Col>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      onChange={RadioHandleChange}
                      name="planType"
                      id="validTo"
                      checked={values.planType === "validTo" ? true : false}
                    />
                    Valid till date
                  </Label>
                </FormGroup>
              </Col>
              <FormFeedback
                style={{
                  display:
                    touched.planValidation && errors.planValidation
                      ? "block"
                      : "none",
                }}
              >
                {touched.planValidation && errors.planValidation
                  ? errors.planValidation
                  : ""}
              </FormFeedback>
            </Row>

            {/* {"isLifeTimePlan" && <FormGroup check>
              <Label>
                <Input
                  type="checkbox"
                  name="isLifeTimePlan"
                  defaultChecked={values.isLifeTimePlan}
                  onBlur={handleBlur}
                  value={values.isLifeTimePlan}
                  onChange={LifeTimeplanHandle}
                />
                Life Time Plan
              </Label>
            </FormGroup> */}
            {values.planType === "planDuration" && (
              <FormGroup>
                {/* isLifeTimePlan */}
                <Input
                  type="text"
                  name="planDuration"
                  onBlur={handleBlur}
                  value={values.planDuration}
                  onChange={handleChange}
                  invalid={
                    errors.planDuration && touched.planDuration ? true : false
                  }
                  id="exampleEmail"
                  placeholder="Enter Plan Duration ( Year )"
                />

                <FormFeedback>
                  {errors.planDuration && touched.planDuration
                    ? errors.planDuration
                    : ""}{" "}
                </FormFeedback>
              </FormGroup>
            )}

            {values.planType === "validTo" && (
              <>
                {" "}
                <FormGroup>
                  <Input
                    name="validTo"
                    min={moment(new Date()).format("YYYY-MM-DD")}
                    value={moment(values.validTo).format("YYYY-MM-DD")}
                    invalid={errors.validTo && touched.validTo ? true : false}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="date"
                  />
                  <FormFeedback>
                    {errors.validTo && touched.validTo ? errors.validTo : ""}{" "}
                  </FormFeedback>
                </FormGroup>
              </>
            )}

            <Label>License Type</Label>
            <FormGroup name="license" onChange={handleChange} check>
              <Row xs="2">
                <Col>
                  <Label>
                    <Input
                      type="checkbox"
                      onBlur={handleBlur}
                      onChange={LicenseHandle}
                      checked={values.isRenewal ? false : values.isParkLicense}
                      defaultChecked={values.isParkLicense}
                      value={values.isParkLicense}
                      name="isParkLicense"
                    />
                    Park License
                  </Label>
                </Col>

                <Col>
                  <Label>
                    <Input
                      type="checkbox"
                      defaultChecked={values.isKennelLicense}
                      onBlur={handleBlur}
                      value={values.isKennelLicense}
                      name="isKennelLicense"
                      checked={
                        values.isRenewal ? false : values.isKennelLicense
                      }
                      onChange={LicenseHandle}
                    />
                    Kennel License
                  </Label>
                </Col>

                <Col>
                  <Label>
                    <Input
                      type="checkbox"
                      onBlur={handleBlur}
                      name="isDogLicense"
                      checked={values.isRenewal ? false : values.isDogLicense}
                      defaultChecked={values.isDogLicense}
                      value={values.isDogLicense}
                      onChange={LicenseHandle}
                    />
                    Dog License
                  </Label>
                </Col>

                <Col>
                  <Label>
                    <Input
                      type="checkbox"
                      onBlur={handleBlur}
                      checked={values.isRenewal}
                      defaultChecked={values.isRenewal}
                      value={values.isRenewal}
                      name="isRenewal"
                      onChange={LicenseHandle}
                    />{" "}
                    Renewal
                  </Label>
                </Col>
              </Row>
              {values.isRenewal ? (
                <FormGroup check>
                  <Label>Renewal For</Label>
                  <Row>
                    <Col>
                      <Label>
                        <Input
                          type="checkbox"
                          onBlur={handleBlur}
                          onChange={RenewalLicenseHandle}
                          checked={values.isParkLicense}
                          defaultChecked={values.isParkLicense}
                          value={values.isParkLicense}
                          name="isParkLicense"
                        />
                        Park License
                      </Label>
                    </Col>

                    <Col>
                      <Label>
                        <Input
                          type="checkbox"
                          defaultChecked={values.isKennelLicense}
                          onBlur={handleBlur}
                          value={values.isKennelLicense}
                          name="isKennelLicense"
                          checked={values.isKennelLicense}
                          onChange={RenewalLicenseHandle}
                        />
                        Kennel License
                      </Label>
                    </Col>

                    <Col>
                      <Label>
                        <Input
                          type="checkbox"
                          onBlur={handleBlur}
                          name="isDogLicense"
                          checked={values.isDogLicense}
                          defaultChecked={values.isDogLicense}
                          value={values.isDogLicense}
                          onChange={RenewalLicenseHandle}
                        />
                        Dog License
                      </Label>
                    </Col>
                  </Row>
                </FormGroup>
              ) : (
                ""
              )}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              {loading && <CustomButtonLoader />}
              Submit
            </Button>
            <Button
              color="secondary"
              type="reset"
              onClick={() => {
                plantoggle(resetForm({}));
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
}
